var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9991 1.25C7.71886 1.25 4.24906 4.71979 4.24906 9V9.7041C4.24906 10.401 4.04277 11.0824 3.65619 11.6622L2.50759 13.3851C1.17449 15.3848 2.1922 18.1028 4.51079 18.7351C5.2664 18.9412 6.0284 19.1155 6.7948 19.2581L6.7967 19.2632C7.56569 21.3151 9.62101 22.75 11.999 22.75C14.377 22.75 16.4323 21.3151 17.2013 19.2632L17.2032 19.2581C17.9696 19.1155 18.7317 18.9412 19.4873 18.7351C21.8059 18.1028 22.8236 15.3848 21.4905 13.3851L20.3419 11.6622C19.9554 11.0824 19.7491 10.401 19.7491 9.7041V9C19.7491 4.71979 16.2793 1.25 11.9991 1.25ZM15.3755 19.537C13.1325 19.805 10.8655 19.8049 8.62251 19.5369C9.33347 20.5585 10.57 21.25 11.999 21.25C13.428 21.25 14.6645 20.5585 15.3755 19.537ZM5.74906 9C5.74906 5.54822 8.54728 2.75 11.9991 2.75C15.4508 2.75 18.2491 5.54822 18.2491 9V9.7041C18.2491 10.6972 18.543 11.668 19.0939 12.4943L20.2425 14.2172C21.0076 15.3649 20.4235 16.925 19.0927 17.288C14.4484 18.5546 9.54972 18.5546 4.90547 17.288C3.57464 16.925 2.99049 15.3649 3.75566 14.2172L4.90427 12.4943C5.45512 11.668 5.74906 10.6972 5.74906 9.7041V9Z",
    fill: "#F7F6FD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.fa30925b394011c921a417ed49dbcc28.svg";
export { ForwardRef as ReactComponent };